export default __webpack_public_path__ + "static/media/funeral-icon.b4f05b25.svg";